const isValidMinute = (minute: number): boolean => Number.isInteger(minute) && minute >= 0 && minute < 60;
const isValidHour = (hour: number): boolean => Number.isInteger(hour) && hour >= 0 && hour < 24;
const TIME_REGEX = /^\d{0,2}?:?\d{0,2}$/u;

export const isTimeValid = (value: string): boolean => {
  if (!TIME_REGEX.test(value)) {
    return false;
  }

  const parts = value.split(':');
  const hourString = parts[0] || '';
  const minuteString = parts[1] || '';
  const hours = parseInt(hourString) || 0;
  const minutes = parseInt(minuteString) || 0;

  if (!isValidHour(hours) || !isValidMinute(minutes)) {
    return false;
  }

  return !(minutes < 10 && Number(minuteString[0]) > 5);
};
